import Component from './AlertForgettable.vue';
import store from '../../store';

export class AlertForgettable {

    install (Vue) {
        const namespace = 'alert_forgetable_';

        const getStorageKey = (key) => {
            const user = store.getters['auth/user'];
            if (user && user.id != null) {
                return namespace + user.id + '_' + key;
            }
            return namespace + key;
        };

        Vue.prototype.$alertForgettable = function (key, message, options) {
            if (!window.localStorage.getItem(getStorageKey(key))) {
                let defaultOptions = {
                    isModal: false,
                    isForgettable: true
                };
                options = Object.assign(defaultOptions, options);

                let wrapper = document.getElementById(namespace + key);
                if (wrapper) {
                    wrapper.parentNode.removeChild(wrapper);
                }
                wrapper = document.createElement('div');
                wrapper.id = namespace + key;
                document.body.appendChild(wrapper);
                const ComponentCtor = Vue.extend(Component);
                new ComponentCtor({
                    propsData: {
                        name: key,
                        content: message,
                        isModal: options.isModal,
                        isForgettable: options.isForgettable,
                        callback: options.callback
                    }
                }).$mount(wrapper);
            }
        };

        Vue.prototype.$alertForgettableRemove = function (key, forget) {
            let wrapper = document.getElementById(namespace + key);
            if (wrapper) {
                if (forget) {
                    window.localStorage.setItem(getStorageKey(key), true);
                }
                wrapper.parentNode.removeChild(wrapper);
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/components/components/AlertForgettable.js